module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "chap-num"
  }, [_vm._v("Six")]), _vm._v(" "), _c('h3', {
    staticClass: "chap-title"
  }, [_vm._v("Dialogue with my dead friend")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mum left and I waited patiently for Dad to wake up. But Dad snored noisily. I got tired of waiting. I went out into the street and encountered the new cycle. It had begun at night and was now real.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were loud cries from Madame Koto’s bar. It was as if many women had fallen into trances and were possessed. The street was crowded with neighbours and new people with odd faces. Soon I pieced together what was happening. People were talking about the old leopard they had glimpsed in the forest. Its breathing was poor and its growling was hoarse. People had gone hunting for the leopard with dane guns and machetes, but hadn’t found it. On their way back they had come upon the enormous figure of Madame Koto, rolling on the ground, raving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was when the community discovered that someone had dumped a bucket of something disgusting in front of her bar. I hurried over to see for myself. The crowd there was solid. Madame Koto seemed quite insane. She lunged at us, uttering the most terrifying threats. Her women stood around, with handkerchiefs to their noses. And right next to Madame Koto’s new car, in the middle of her "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("frontyard, was the appalling bucket. We looked on with fear, knowing that retaliation would come at us in unpleasant ways.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She kept jumping up and down. Cursing. Crying out with the pain of her bad foot and her abnormal pregnancy. She was like a mad witch. In a harsh voice, she ordered her men to fetch people to clear the mess from her barfront. She seemed like her own nemesis. Everyone looked on, thinking about the dead carpenter. Thinking about his son, whom Madame Koto’s driver had killed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While I watched Madame Koto shrieking, a cool wind blew around me. A flash of dazzling light shot through my brain. Then something nearby electrified my skin. I turned and saw that it was the spirit of Ade. The dead son of the dead carpenter. My friend. In his blue suit, he seemed very healthy. With a mischievous smile, he said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How is my father?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He has been buried,’ I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But who killed him?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t know. I saw a thug …’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who gave the thug the order?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m not sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How is your father?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s asleep.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How do you know?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because he was fast asleep when I left him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your mother was singing when she left you, but she is not singing now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why not?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because she knows something bad is happening.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Where?’")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll tell you when my father has been buried.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He has.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How do you know?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was there.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Where?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the forest.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What forest?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That one.’ I pointed, turning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But when I looked, I was amazed to find that the forest had vanished. I turned back to my friend, but he too had disappeared. Instead, I saw Madame Koto descending on me. She began hitting me on the head, howling. I ran, fell, and got up. A man in the crowd held me and said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why do you talk to yourself when your father is in trouble?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’ I asked, confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Wake up!’ he shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was stunned into a new alertness. Everything was turning too fast. I ran home. The world was spinning. The road kept opening and shutting. Voices were whispering. The forest had reappeared. When I got to our room, five policemen, acting on rumours spread by the Party of the Poor, had come to arrest Dad for the murder of the carpenter.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31fd11a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/012_Part01Sub01Ch06.vue
// module id = 99
// module chunks = 0